import { FC } from 'react';
import { InfoTitleProps } from './InfoTitle.types';
import { StyledText } from './InfoTitle.styles';

const InfoTitle: FC<InfoTitleProps> = ({ css, children, testId, ...props }) => {
  return (
    <StyledText css={{ ...css }} data-testid={testId} {...props}>
      {children}
    </StyledText>
  );
};

export default InfoTitle;
